import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import PinCodeResetStep1UI from './PinCodeResetStep1UI.js'

class PinCodeResetStep1SF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: [],
      submitted: false,
    }
  }

  render() {
    return (
      <PinCodeResetStep1UI
        context={this.props.context}
        messageList={this.state.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        // phoneNumber
        phoneNumber={this.props.phoneNumber}
        onPhoneNumberChange={this.props.onPhoneNumberChange}
        phoneNumberError={this.props.phoneNumberError}
        setPhoneNumberError={this.props.setPhoneNumberError}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/pub/pinCodeReset`,
      this.onSubmitCallback, {
        phoneNumber: this.props.phoneNumber
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'phoneNumber':
            this.props.setPhoneNumberError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({
      successMsg: response.success,
      submitted: false
    })

    if (errorList.length === 0) {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
      this.props.setView('verification')
    }
  }

  getMessages(context) {
    let arr = [
      'c_phone_number',
      'c_continue',
      'c_tip_pincode_reset'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pub_reset_pin', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default PinCodeResetStep1SF
